import React, { useState, useEffect, useRef } from "react";
import { MdOutlineReportProblem } from "react-icons/md";
import { useNavigate, useParams } from "react-router-dom";
import config from "../../config";
import FavoriteBorderOutlinedIcon from "@mui/icons-material/FavoriteBorderOutlined";
import FavoriteIcon from "@mui/icons-material/Favorite";
import BedOutlined from "@mui/icons-material/BedOutlined";
import BathtubOutlinedIcon from "@mui/icons-material/BathtubOutlined";
import "./Preview.css";
import StraightenOutlinedIcon from "@mui/icons-material/StraightenOutlined";
import MapsHomeWorkOutlinedIcon from "@mui/icons-material/MapsHomeWorkOutlined";
import { IoBedOutline, IoHammer } from "react-icons/io5";

import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "react-datepicker/dist/react-datepicker.css"; // Import the DatePicker CSS
import moment from "moment";
import axios from "axios";
import CustomDatePickerComponent from "../../components/CustomDatePickerComponent";
import FeatureChipsContainer from "../MyProperties/FeatureChipsContainer";
import PropertyComponent from "../../components/PropertyComponent";

import DetailsAndFacts from "./DetailAndFact";
import { BsShare } from "react-icons/bs";
import { deleteApi, postApi } from "../AppApis";
import { TbBath } from "react-icons/tb";
import { RxDimensions } from "react-icons/rx";
import { PiBarbell, PiCalendarDotsBold } from "react-icons/pi";
import { formatUSAPrice } from "../../helpers/utils";
import ReportProperty from "../MyProperties/ReportProperty";
import ShareComponent from "../../components/ShareComponent/ShareComponent";
import SignInRegister from "../../components/Modal/AuthModal";
import { checkToken } from "../../helpers/api";
import { useProfile } from "../../contexts/ProfileContext";
import { BiSolidCarGarage } from "react-icons/bi";
import { showErrorToast, showSuccessToast } from "../utils";
import ImageModal from "../../components/Modal/ImageModal/ImageModal";
import MLSDisclaimer from "../../components/PropertyDetailPreview/MLSDisclaimer";
import LeafletLocateMapLocation from "../../components/PropertyDetailPreview/LeafletLocateMap";
import { FaSwimmingPool } from "react-icons/fa";
import { FaPlantWilt } from "react-icons/fa6";
import RenderImages from "./RenderImages";

const PreviewPage = ({ propertyId, isHomePage, setPreviewModal, setIsFavoriteChanged, isFavoriteChanged, isLogin: isLoginProps }) => {
    const { profileData } = useProfile();
    const searchParams = new URLSearchParams(window.location.search);
    const from = searchParams.get("from");

    const [seeAllclicked, setSeeAllclicked] = useState(false);
    const [property, setProperty] = useState({});
    const [showTourModal, setShowTourModal] = useState(false);
    const [selectedDate, setSelectedDate] = useState(null);
    const [profileDetail, setProfileDetail] = useState({
        firstName: "",
        lastName: "",
        email: "",
        role: "",
        phone: "",
        userId: "",
        profile_pic: "",
    });
    const [isFavorite, setIsFavorite] = useState(false);
    const [EstPayment, setEstPayment] = useState(null);
    const [images, setImages] = useState([]);
    const { id } = useParams();
    const navigate = useNavigate();
    const [features, setFeatures] = useState([]);
    const [priceFeatures, setPriceFeatures] = useState([]);
    const [isShareModal, setIsShareModal] = useState(false);
    const [isReportModalVisible, setIsReportModalVisible] = useState(false);
    const [displayedDescription, setDisplayedDescription] = useState(`${property?.description?.slice(0, 400)}...`);
    const [isExpanded, setIsExpanded] = useState(false);
    const [favoriteProperties, setFavoriteProperties] = useState([]);
    const [isLogin, setIsLogin] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const modalRef = useRef(null);
    const detailRef = useRef(null);
    const shareModalRef = useRef(null);
    const modalContentRef = useRef(null);
    const owner_info = property?.seller_info;

    let propertiesArray = [];

    const [selectedImage, setSelectedImage] = useState();
    const [openAuthModal, setOpenAuthModal] = useState(false);

    const handleClose = () => setOpenAuthModal(false);

    const getPropertyById = async (propertyId) => {
        if (propertyId) {
            setIsLoading(true);
            try {
                const accessToken = localStorage.getItem("authUser");
                let response;
                if (accessToken) {
                    const token = accessToken.replace(/^"|"$/g, "");
                    response = await axios.get(`${config.get("API_URL")}/properties/get_public_property/${propertyId}`, {
                        headers: {
                            Authorization: `Bearer ${token}`,
                        },
                    });
                } else {
                    response = await axios.get(`${config.get("API_URL")}/properties/get_public_property/${propertyId}`);
                }
                setIsFavorite(response?.is_favorited);
                // Sync favoriteProperties array with the API response
                if (response?.is_favorited && !favoriteProperties.includes(response?.ListingId)) {
                    setFavoriteProperties((prev) => [...prev, response?.ListingId]);
                }
                setProperty(response);
                setDisplayedDescription(`${response?.description?.slice(0, 400)}...`);
            } catch (error) {
                console.log("Error::", error);
            } finally {
                setIsLoading(false);
            }
        }
    };
    useEffect(() => {
        if (id || propertyId) {
            getPropertyById(id || propertyId);
        }
    }, [id, propertyId]);

    const checkLogin = async () => {
        try {
            const response = await checkToken();
            if (response === 401) {
                setIsLogin(false);
            } else {
                setIsLogin(true);
            }
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        checkLogin();
    }, []);

    useEffect(() => {
        setDisplayedDescription(isExpanded ? property?.description : `${property?.description?.slice(0, 400)}...`);
    }, [isExpanded]);

    useEffect(() => {
        if (property) {
            getEstimateInterestRate();
        }
    }, [property]);

    useEffect(() => {
        if (property) {
            setPriceFeatures([
                { icon: <BedOutlined />, text: `${property.beds || "---"} beds` },
                { icon: <BathtubOutlinedIcon />, text: `${property.baths || "---"} baths` },
                { icon: <StraightenOutlinedIcon />, text: `${property.LivingArea || "---"} sqft` },
            ]);
            setFeatures([
                { icon: <IoHammer />, text: `Built in ${property?.built_in || "---"}` },
                { icon: <StraightenOutlinedIcon />, text: `${property?.LivingArea || "---"} sqft` },
                { icon: <MapsHomeWorkOutlinedIcon />, text: `${property?.type || "---"}` },
                { icon: <BiSolidCarGarage />, text: `${property?.attached_garage || "0"} attached garage` },
            ]);

            const img = property?.media ?? property?.images;
            setImages(img);
            setSelectedImage(img ? img[0] : "");
        }
    }, [property]);
    const getEstimateInterestRate = async () => {
        const accessToken = localStorage.getItem("authUser");

        if (property.price && accessToken) {
            const token = accessToken.replace(/^"|"$/g, "");
            try {
                const response = await axios.post(
                    `${config.get("API_URL")}/property-services/calculate_mortgage`,
                    {
                        property_price: property.price,
                    },
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                        },
                    }
                );
                setEstPayment(response);
            } catch (error) {
                console.log("Error::", error);
            }
        }
    };

    useEffect(() => {
        const accessToken = localStorage.getItem("authUser");
        if (accessToken) {
            const token = accessToken.replace(/^"|"$/g, "");
            const profileUrl = `${config.get("API_URL")}/user/profile`;
            fetch(profileUrl, {
                method: "GET",
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            })
                .then((response) => response.json())
                .then((data) => {
                    setProfileDetail({
                        firstName: data.first_name,
                        lastName: data.last_name,
                        email: data.email,
                        role: data.role,
                        userId: data.uuid,
                        phone: data.phone,
                        profile_pic: data.profile_pic,
                    });
                })
                .catch((error) => {
                    console.error("Error fetching profile:", error);
                });
        }
    }, []);

    const handleContactClick = async () => {
        try {
            const response = await checkToken();
            if (response === 401) {
                setOpenAuthModal(true);
            } else {
                const propertyAddressParts = [];

                if (property.StreetNumber) propertyAddressParts.push(property.StreetNumber);
                if (property.StreetName) propertyAddressParts.push(property.StreetName);
                if (property.StreetSuffix) propertyAddressParts.push(property.StreetSuffix);

                const propertyAddress = propertyAddressParts.join(" ");
                const initialMessage = `Hi ${profileData?.first_name}, how can we help you with ${propertyAddress}? Let me know what information I can get you!`;

                if (owner_info && Object.keys(owner_info).length > 0) {
                    navigate(`/chat?chat_id=${owner_info.user_id}-${property.ListingId}&property_id=${property.ListingId}`, {
                        state: {
                            seller_id: owner_info.user_id,
                            name: property.name || "Unnamed item",
                            price: property.price,
                            property_id: property.property_id,
                            owner_email: owner_info.email,
                            owner_name: owner_info.first_name,
                            address: property.address,
                            owner_profile: owner_info.profile_pic,
                            user_id: owner_info.user_id,
                            messageValue: initialMessage,
                        },
                    });
                } else {
                    localStorage.setItem("initialMessage", initialMessage);
                    localStorage.setItem("latestProperty", JSON.stringify(property));
                    localStorage.setItem("propertyAddress", propertyAddress);
                    navigate(`/chat?chat_id=${property.ListingId}&property_id=${property.ListingId}`, {
                        state: {
                            messageValue: initialMessage,
                            property_id: property.property_id,
                            name: property.name || "Unnamed item",
                            price: property.price,
                        },
                    });
                }
            }
        } catch (error) {
            console.log(error);
        }
    };

    const handleGetQualifiedClick = () => {
        navigate("/services/financing");
    };

    // Open the tour request modal
    const handleRequestTourClick = async () => {
        const response = await checkToken();
        if (response === 401) {
            setOpenAuthModal(true);
        } else {
            setShowTourModal(true);
        }
    };

    // Close the tour request modal
    const handleCloseTourModal = () => {
        setShowTourModal(false);
        setSelectedDate(null);
    };

    const handleScheduleTour = () => {
        const accessToken = localStorage.getItem("authUser");
        if (!accessToken) {
            showErrorToast("You must be logged in to schedule a tour.", {
                autoClose: 3000,
                pauseOnHover: false,
            });
            return;
        }

        if (!selectedDate) {
            showErrorToast("Please select a date for the tour.", {
                autoClose: 3000,
                pauseOnHover: false,
            });
            return;
        }

        const token = accessToken.replace(/^"|"$/g, "");
        let tourRequestData = {
            request_tour: {
                requester_name: `${profileDetail.firstName} ${profileDetail.lastName}`,
                requester_id: profileDetail.userId,
                // Using moment.js to format the date
                requested_datetime: moment(selectedDate).format("YYYY-MM-DDTHH:mm:ss"),
            },
        };
        if (property?.property_id) {
            tourRequestData.ListingId = property?.ListingId;

            // tourRequestData.property_id = property?.property_id;
        } else if (property?.ListingId) {
            tourRequestData.ListingId = property?.ListingId;
        }

        const tourUrl = `${config.get("API_URL")}/property-services/create_showing_request`;

        fetch(tourUrl, {
            method: "POST",
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            },
            body: JSON.stringify(tourRequestData),
        })
            .then(async (response) => {
                if (!response.ok) {
                    return response.json().then((errorData) => {
                        showErrorToast(errorData.detail || "An error occurred. Please try again.", {
                            autoClose: 3000,
                            pauseOnHover: false,
                        });
                        console.error("Error response data:", errorData); // Log error response
                        throw new Error(errorData.message || "Failed to schedule the tour.");
                    });
                }
                return response.json();
            })
            .then((data) => {
                showSuccessToast("Request Successfully Sent! Please check your email or app notifications for updates", {
                    autoClose: 3000,
                    pauseOnHover: false,
                });
                handleCloseTourModal();
            })
            .catch((error) => {
                console.error("Error scheduling tour:", error);
            });
    };
    const onClickShare = () => {
        if (!isLogin) {
            return setOpenAuthModal(true);
        }
        setIsShareModal(property.ListingId);
    };

    const returnImageUrl = (imageObj) => {
        let imageUrl = imageObj?.MediaKey;
        return `https://image.onmls.com/public/images/${imageUrl}`;
    };
    const formatPrice = (price) => {
        try {
            // Ensure the input is a valid number
            const numericPrice = typeof price === "number" ? price : parseFloat(price?.toString().replace(/[^\d.-]/g, ""));

            // Return formatted price with commas, or fallback if invalid
            return numericPrice >= 0 ? numericPrice.toLocaleString("en-US") : "---";
        } catch (error) {
            console.error("Error formatting price:", error);
            return "---";
        }
    };

    const onPreQualified = async () => {
        const response = await checkToken();
        if (response === 401) {
            setOpenAuthModal(true);
        } else {
            navigate("/services/financing");
        }
    };
    const checkFavorite = (propertyId) => {
        return favoriteProperties.includes(propertyId.ListingId);
    };
    const handleFavorite = async (propertyId) => {
        const isFav = checkFavorite(propertyId);
        const path = "/property-services/favorite_property";
        let response;
        const data = { ...propertyId };
        if (isFav) {
            response = await deleteApi(path, { listing_id: data.ListingId });
            const filterFav = favoriteProperties.filter((item) => item != propertyId.ListingId);
            setFavoriteProperties(filterFav);
            setIsFavorite(false);
            toast.success("Property removed from favorites", { toastId: "remove-fav" });
        } else {
            response = await postApi(path, data);

            if (response.error === 401) {
                setOpenAuthModal(true);
                return;
            }
            toast.success("Property added to favorites", { toastId: "add-fav" });
            const filterFav = [...favoriteProperties, propertyId.ListingId];
            setFavoriteProperties(filterFav);
            setIsFavorite(true);
        }
        if (setIsFavoriteChanged) {
            setIsFavoriteChanged(isFavoriteChanged + 1);
        }
    };

    return (
        <div className="tw-w-full tw-bg-black/50">
            <div
                className={`custom-scrollbare tw-bg-black tw-bg-opacity-75 tw-w-full  tw-fixed tw-max-h-[100dvh]  max-sm:tw-max-h-[100dvh] tw-inset-0 md:tw-z-[101] tw-z-[99999] tw-overflow-hidden tw-text-primary-500 tw-pb-10 max-sm:tw-pb-0`}
                style={{ zIndex: 101 }}
            >
                <SignInRegister open={openAuthModal} handleClose={handleClose} setIsLogin={setIsLogin} />
                <div
                    ref={modalContentRef}
                    className={`tw-bg-white tw-text-black tw-h-screen tw-overflow-y-auto tw-w-full ${isHomePage ? "sm:tw-w-[95%] md:tw-w-[90%] lg:tw-w-[80%] tw-max-w-7xl" : ""} tw-mx-auto`}
                >
                    {isShareModal && (
                        <ShareComponent
                            shareModalRef={shareModalRef}
                            selectedFile={{ url: `/preview/${isShareModal}` }}
                            onClose={() => setIsShareModal(false)}
                            property={property}
                        />
                    )}
                    <header className="tw-sticky tw-top-0 tw-z-[100] tw-bg-tertiary tw-w-full tw-shadow-md tw-shrink-0">
                        <div className="tw-w-full tw-max-w-none tw-px-4 sm:tw-px-6 lg:tw-px-8 tw-py-3 tw-flex tw-items-center tw-justify-between tw-text-white tw-min-h-[60px] tw-gap-2 sm:tw-gap-4">
                            {/* Left Section - Back Navigation */}
                            <div className="tw-flex tw-items-center tw-gap-2 tw-shrink-0">
                                <i
                                    onClick={() => {
                                        navigate(isLogin ? "/properties" : "/login");
                                        setPreviewModal(false);
                                    }}
                                    className="fi fi-rr-angle-square-left md:tw-hidden tw-text-[20px] sm:tw-text-[24px] tw-cursor-pointer hover:tw-text-gray-200 tw-p-1"
                                ></i>
                                <button
                                    onClick={() =>
                                        from?.includes("chat")
                                            ? (() => {
                                                  const chatUrl = from.includes("?") ? from : `/chat?chat_id=${from}`;
                                                  // Ensure property_id is included if navigating back to property-related chat
                                                  if (from.includes(property.ListingId) && !chatUrl.includes("property_id")) {
                                                      navigate(chatUrl + `&property_id=${property.ListingId}`);
                                                  } else {
                                                      navigate(chatUrl);
                                                  }
                                              })()
                                            : isHomePage
                                              ? setPreviewModal(false)
                                              : navigate(isLogin ? "/properties" : "/login")
                                    }
                                    className="tw-hidden md:tw-flex tw-items-center tw-gap-2 tw-px-3 lg:tw-px-4 tw-py-2 tw-bg-white tw-text-gray-800 tw-rounded-lg tw-border tw-hover:tw-bg-gray-50 tw-transition-colors tw-text-sm lg:tw-text-base"
                                >
                                    <span>Back</span>
                                </button>
                            </div>

                            {/* Center Section - Company Name */}
                            <div className="tw-flex-1 tw-flex tw-justify-center tw-min-w-0 tw-px-2">
                                <p className="tw-font-space-grotesk tw-font-semibold tw-text-[16px] sm:tw-text-[18px] tw-text-center tw-truncate">
                                    {config.get("COMPANY_NAME")}
                                </p>
                            </div>

                            {/* Right Section - Action Buttons */}
                            <nav className="tw-flex tw-items-center tw-gap-1 sm:tw-gap-2 tw-shrink-0">
                                {/* Favorite Button - Now visible on all screens */}
                                <button
                                    className="tw-flex tw-items-center tw-gap-1 lg:tw-gap-2 tw-px-2 lg:tw-px-3 tw-py-2 tw-rounded-lg tw-transition-colors hover:tw-bg-white/10"
                                    onClick={() => handleFavorite(property)}
                                >
                                    {isFavorite ? (
                                        <>
                                            <FavoriteIcon style={{ color: "red" }} className="tw-w-5 lg:tw-w-5 tw-h-5 lg:tw-h-5" />
                                            <span className="tw-text-xs lg:tw-text-sm tw-font-medium tw-hidden lg:tw-inline">Saved</span>
                                        </>
                                    ) : (
                                        <>
                                            <FavoriteBorderOutlinedIcon className="tw-w-5 lg:tw-w-5 tw-h-5 lg:tw-h-5 tw-text-white" />
                                            <span className="tw-text-xs lg:tw-text-sm tw-font-medium tw-hidden lg:tw-inline">Save</span>
                                        </>
                                    )}
                                </button>

                                {/* Share Button - Now visible on all screens */}
                                <button
                                    onClick={onClickShare}
                                    className="tw-flex tw-items-center tw-gap-1 lg:tw-gap-2 tw-px-2 lg:tw-px-3 tw-py-2 tw-rounded-lg tw-transition-colors hover:tw-bg-white/10"
                                >
                                    <BsShare className="tw-w-5 lg:tw-w-5 tw-h-5 lg:tw-h-5 tw-text-white" />
                                    <span className="tw-text-xs lg:tw-text-sm tw-font-medium tw-hidden lg:tw-inline">Share</span>
                                </button>

                                {/* Report Button */}
                                <button
                                    onClick={() => setIsReportModalVisible(true)}
                                    className="tw-flex tw-items-center tw-gap-1 tw-px-2 tw-py-2 tw-rounded-lg tw-transition-colors hover:tw-bg-white/10"
                                >
                                    <MdOutlineReportProblem className="tw-w-5 lg:tw-w-5 tw-h-5 lg:tw-h-5 tw-text-white" />
                                    <span className="tw-text-xs lg:tw-text-sm tw-font-medium tw-hidden sm:tw-inline">Report</span>
                                </button>
                            </nav>
                        </div>
                    </header>
                    {/* Buttons */}

                    <div className=" tw-w-full tw-flex tw-justify-center tw-px-2 md:tw-px-4">
                        <div className="tw-p-5 lg:tw-px-0 tw-flex tw-gap-2 tw-w-full tw-max-w-6xl" ref={modalRef}>
                            <button className="tw-px-5 tw-py-1 tw-bg-[#EAEFF4]">Highlights</button>
                            <button
                                className="tw-px-5 tw-py-1"
                                onClick={() => {
                                    if (detailRef.current) {
                                        detailRef.current.scrollIntoView({ behavior: "smooth" });
                                    }
                                }}
                            >
                                Details
                            </button>
                        </div>
                    </div>
                    <div className="tw-px-2 md:tw-px-4">
                        {!isLoading ? (
                            <>
                                <div className="tw-flex tw-flex-col tw-items-center xl:tw-flex-col tw-w-full tw-relative">
                                    {/* SHOW IMAGES - Mobile action buttons moved to header for clean image display */}
                                    <RenderImages
                                        property={property}
                                        images={images}
                                        selectedImage={selectedImage}
                                        setSelectedImage={setSelectedImage}
                                        setSeeAllclicked={setSeeAllclicked}
                                        returnImageUrl={returnImageUrl}
                                    />
                                </div>

                                <div className="tw-min-h-screen  tw-bg-white tw-p-6">
                                    <div className="tw-grid tw-grid-cols-[1fr_300px] max-sm:tw-grid-cols-1 tw-gap-6 tw-max-w-6xl tw-mx-auto">
                                        {/* Main Content */}
                                        <div>
                                            {/* Header */}
                                            <div className="tw-flex tw-justify-between max-sm:tw-flex-wrap max-sm:tw-gap-2 tw-items-start tw-mb-6 tw-border-b tw-pb-4">
                                                <h1 className="tw-text-[24px] tw-font-semibold">
                                                    {property?.full_address ? (
                                                        <>{property?.full_address}</>
                                                    ) : (
                                                        <>
                                                            {property?.StreetNumber} {property?.StreetName} {property?.StreetSuffix}
                                                            {", "}
                                                            {property?.City}
                                                            {", "}
                                                            {property?.StateOrProvince} {property?.PostalCode}
                                                        </>
                                                    )}
                                                </h1>
                                                {/* Save/Share buttons - Hidden on mobile since we have floating buttons above images */}
                                                <div className="tw-hidden md:tw-flex tw-gap-2">
                                                    {isFavorite ? (
                                                        <button
                                                            onClick={() => handleFavorite(property)}
                                                            className="tw-flex tw-items-center tw-gap-1 tw-text-[#FF5757] tw-text-md"
                                                        >
                                                            <svg className="tw-h-[18px] tw-w-[18px]" fill="red" stroke="red" viewBox="0 0 24 24">
                                                                <path
                                                                    strokeLinecap="round"
                                                                    strokeLinejoin="round"
                                                                    strokeWidth="2"
                                                                    d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"
                                                                />
                                                            </svg>
                                                            Save
                                                        </button>
                                                    ) : (
                                                        <button
                                                            onClick={() => handleFavorite(property)}
                                                            className="tw-flex tw-items-center tw-gap-1 tw-text-[#FF5757] tw-text-md"
                                                        >
                                                            <svg
                                                                className="tw-h-[18px] tw-w-[18px]"
                                                                fill="none"
                                                                stroke="currentColor"
                                                                viewBox="0 0 24 24"
                                                            >
                                                                <path
                                                                    strokeLinecap="round"
                                                                    strokeLinejoin="round"
                                                                    strokeWidth="2"
                                                                    d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"
                                                                />
                                                            </svg>
                                                            Save
                                                        </button>
                                                    )}

                                                    <button
                                                        onClick={onClickShare}
                                                        className="tw-flex tw-items-center tw-gap-1 tw-text-gray-600 tw-text-md"
                                                    >
                                                        <svg
                                                            className="tw-h-[16px] tw-w-[16px]"
                                                            fill="none"
                                                            stroke="currentColor"
                                                            viewBox="0 0 24 24"
                                                        >
                                                            <path
                                                                strokeLinecap="round"
                                                                strokeLinejoin="round"
                                                                strokeWidth="2"
                                                                d="M8.684 13.342C8.886 12.938 9 12.482 9 12c0-.482-.114-.938-.316-1.342m0 2.684a3 3 0 110-2.684m0 2.684l6.632 3.316m-6.632-6l6.632-3.316m0 0a3 3 0 105.367-2.684 3 3 0 00-5.367 2.684zm0 9.316a3 3 0 105.368 2.684 3 3 0 00-5.368-2.684z"
                                                            />
                                                        </svg>
                                                        Share
                                                    </button>
                                                </div>
                                            </div>

                                            {/* Description */}
                                            <div className="tw-mb-6">
                                                <p className="tw-text-black tw-text-justify tw-text-[16px] tw-leading-relaxed">
                                                    {displayedDescription}
                                                    {property?.description && property.description?.length > 400 && (
                                                        <>
                                                            {isExpanded ? (
                                                                <button
                                                                    onClick={() => setIsExpanded((pre) => !pre)}
                                                                    className="tw-text-black tw-font-semibold tw-ml-1"
                                                                >
                                                                    Read Less
                                                                </button>
                                                            ) : (
                                                                <button
                                                                    onClick={() => setIsExpanded((pre) => !pre)}
                                                                    className="tw-text-black tw-font-semibold tw-ml-1"
                                                                >
                                                                    Read full description
                                                                </button>
                                                            )}
                                                        </>
                                                    )}
                                                </p>
                                            </div>

                                            {/* Facilities */}
                                            <div className="tw-mb-8">
                                                <h2 className="tw-text-[20px] tw-font-semibold tw-mb-4">Facilities</h2>
                                                <div className="tw-grid tw-grid-cols-4 max-sm:tw-grid-cols-2 tw-gap-4">
                                                    <div className="tw-flex tw-items-center tw-gap-2">
                                                        <IoBedOutline className="tw-text-[22px]" />

                                                        <span className="tw-text-[16px]">{property?.beds || "---"} Bedrooms</span>
                                                    </div>
                                                    <div className="tw-flex tw-items-center tw-gap-2">
                                                        <TbBath className="tw-text-[22px]" />
                                                        <span className="tw-text-[16px]">{property?.baths || "---"} Bathrooms</span>
                                                    </div>
                                                    <div className="tw-flex tw-items-center tw-gap-2">
                                                        <RxDimensions className="tw-text-[22px]" />
                                                        <span className="tw-text-[16px]">{property?.LivingArea || "--- "} sqft</span>
                                                    </div>
                                                    <div className="tw-flex tw-items-center tw-gap-2">
                                                        <PiBarbell className="tw-text-[22px]" />
                                                        <span className="tw-text-[16px]">No Gym</span>
                                                    </div>
                                                    <div className="tw-flex tw-items-center tw-gap-2">
                                                        <FaPlantWilt />

                                                        <span className="tw-text-[16px]">Garden View</span>
                                                    </div>
                                                    <div className="tw-flex tw-items-center tw-gap-2">
                                                        <FaSwimmingPool />

                                                        <span className="tw-text-[16px]">Pool</span>
                                                    </div>
                                                    <div className="tw-flex tw-items-center tw-gap-2">
                                                        <BiSolidCarGarage />
                                                        <span className="tw-text-[16px]">Garage: {property.attached_garage ? "Yes" : "No"}</span>
                                                    </div>
                                                    <div className="tw-flex tw-items-center tw-gap-2">
                                                        <BiSolidCarGarage />
                                                        <span className="tw-text-[16px]">Garage Spaces: {property.GarageSpaces}</span>
                                                    </div>
                                                    {property.Carportspaces && (
                                                        <div className="tw-flex tw-items-center tw-gap-2">
                                                            <BiSolidCarGarage />
                                                            <span className="tw-text-[16px]">Carport Spaces: {property.Carportspaces}</span>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>

                                            {/* Location */}
                                            <div>
                                                <h2 className="tw-text-[20px] tw-font-semibold tw-mb-4">Location</h2>
                                                <div className="tw-h-[400px] tw-bg-background_color tw-rounded-lg tw-overflow-hidden">
                                                    {" "}
                                                    <LeafletLocateMapLocation
                                                        monthlyPayment={EstPayment?.monthly_payment || "0"}
                                                        agentName={owner_info?.name || "CS"}
                                                        currentValue={formatPrice(property?.price || 0)}
                                                        percentageChange={property?.percentage_change || "0"}
                                                        yearsSpan={property?.years_span || "0"}
                                                        property={property}
                                                        onContactClick={handleContactClick}
                                                        onQualifyClick={handleGetQualifiedClick}
                                                    />
                                                </div>
                                            </div>

                                            {/* More Details Section */}
                                            <div ref={detailRef} className="tw-mt-8">
                                                <h2 className="tw-text-[20px] tw-font-semibold tw-mb-4">More Details And Facts</h2>
                                                <div className="">
                                                    <div>
                                                        <DetailsAndFacts info={property} />
                                                    </div>
                                                </div>
                                                {property?.appliances && property?.appliances.length > 0 && (
                                                    <div className="">
                                                        <h3 className="tw-text-[20px] *:tw-font-medium tw-mb-2 tw-bg-background_color tw-p-4 tw-rounded">
                                                            Appliances
                                                        </h3>

                                                        <div>
                                                            <FeatureChipsContainer
                                                                showOnly={true}
                                                                array={property?.appliances}
                                                                isDisable
                                                                heading="Appliances"
                                                            />
                                                        </div>
                                                    </div>
                                                )}{" "}
                                                {property?.Heating && (
                                                    <div className="">
                                                        <h3 className="tw-font-medium tw-mb-2 tw-bg-gray-100 tw-p-4 tw-rounded">Heating </h3>
                                                        <div>
                                                            <FeatureChipsContainer showOnly={true} array={property?.Heating} isDisable />
                                                        </div>
                                                    </div>
                                                )}{" "}
                                                {property?.ParkingFeatures && property?.ParkingFeatures.length > 0 && (
                                                    <div className="">
                                                        <h3 className="tw-font-medium tw-mb-2 tw-bg-gray-100 tw-p-4 tw-rounded">Parking </h3>
                                                        <div>
                                                            <FeatureChipsContainer showOnly={true} array={property?.ParkingFeatures} isDisable />
                                                        </div>
                                                    </div>
                                                )}
                                                {property?.PoolFeatures && property?.PoolFeatures.length > 0 && (
                                                    <div className="">
                                                        <h3 className="tw-font-medium tw-mb-2 tw-bg-gray-100 tw-p-4 tw-rounded">Pool Features </h3>
                                                        <div>
                                                            <FeatureChipsContainer showOnly={true} array={property?.PoolFeatures} isDisable />
                                                        </div>
                                                    </div>
                                                )}
                                                {property?.construction && (
                                                    <div className="">
                                                        <h3 className="tw-font-medium tw-mb-2 tw-bg-gray-100 tw-p-4 tw-rounded">Construction </h3>
                                                        <div>
                                                            <FeatureChipsContainer showOnly={true} array={property?.construction} isDisable />
                                                        </div>
                                                    </div>
                                                )}{" "}
                                                {property?.materials && (
                                                    <div className="">
                                                        <h3 className="tw-font-medium tw-mb-2 tw-bg-gray-100 tw-p-4 tw-rounded">Materials </h3>
                                                        <div>
                                                            <FeatureChipsContainer showOnly={true} array={property?.materials} isDisable />
                                                        </div>
                                                    </div>
                                                )}{" "}
                                                {property?.Cooling && (
                                                    <div className="">
                                                        <h3 className="tw-font-medium tw-mb-2 tw-bg-gray-100 tw-p-4 tw-rounded">Cooling</h3>
                                                        <div>
                                                            <FeatureChipsContainer showOnly={true} array={property?.Cooling} isDisable />
                                                        </div>
                                                    </div>
                                                )}{" "}
                                                {property?.Sewer && (
                                                    <div className="">
                                                        <h3 className="tw-font-medium tw-mb-2 tw-bg-gray-100 tw-p-4 tw-rounded">Sewer </h3>
                                                        <div>
                                                            <FeatureChipsContainer showOnly={true} array={property?.Sewer} isDisable />
                                                        </div>
                                                    </div>
                                                )}{" "}
                                            </div>
                                        </div>

                                        {/* Price Card - Now in grid layout */}
                                        <div className="tw-relative  tw-h-full ">
                                            <div className="tw-sticky max-sm:tw-relative  tw-top-20 max-sm:tw-top-0  tw-bg-white tw-rounded-lg tw-border-1 tw-p-6 tw-h-fit ">
                                                <div className="tw-mb-6">
                                                    <p className="tw-text-gray-500 tw-mb-1">Price</p>
                                                    <h2 className="tw-text-3xl tw-font-bold">${formatUSAPrice(property?.price)}</h2>
                                                </div>
                                                <button
                                                    onClick={handleContactClick}
                                                    className="tw-w-full tw-flex tw-items-center tw-justify-center tw-bg-[#208177] hover:tw-bg-[#1B6D6E] focus:tw-bg-[#1B6D6E] active:tw-bg-[#186661] disabled:tw-bg-[#208177]/50 disabled:tw-cursor-not-allowed tw-text-white tw-text-[13px] tw-font-bold tw-h-[43px] tw-rounded-lg tw-mb-4 tw-transition-colors tw-duration-200 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-[#208177] focus:tw-ring-offset-2"
                                                >
                                                    Contact
                                                </button>
                                                <div>
                                                    <h3 className="tw-font-medium tw-mb-2">Request a tour</h3>
                                                    <p className="tw-text-sm tw-text-semi_dark_text tw-mb-2">Live tour only available on:</p>
                                                    <p className="tw-text-sm tw-text-semi_dark_text tw-font-medium tw-mb-4">
                                                        Monday – Friday at 10:00am – 5:00pm
                                                    </p>
                                                    <button
                                                        onClick={handleRequestTourClick}
                                                        className="tw-flex tw-flex-row tw-gap-1 tw-items-center tw-justify-center tw-w-full tw-border hover:tw-bg-slate-200 tw-border-[#000000] tw-text-black tw-py-2 tw-rounded"
                                                    >
                                                        <PiCalendarDotsBold />
                                                        Make Appointment
                                                    </button>

                                                    <button
                                                        onClick={onPreQualified}
                                                        className="tw-flex tw-flex-row tw-mt-4 tw-gap-1 tw-items-center tw-justify-center tw-w-full hover:tw-bg-slate-200 tw-border tw-border-[#000000] tw-text-black tw-py-2 tw-rounded"
                                                    >
                                                        Get Prequalified
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {propertiesArray && propertiesArray.length > 0 && (
                                    <div className=" tw-w-full  tw-flex tw-justify-center">
                                        <div className="tw-p-10 tw-max-w-6xl tw-w-full lg:tw-px-0">
                                            <p className="tw-text-tertiary tw-text-[24px] tw-font-[700]">Similar Homes</p>
                                            <div className="tw-flex tw-gap-5 tw-overflow-x-scroll tw-mt-5 tw-w-full">
                                                {propertiesArray?.map((itm, index) => (
                                                    <div
                                                        key={index}
                                                        className="tw-min-w-[300px]"
                                                        onClick={() => {
                                                            setProperty(itm);
                                                            setSelectedImage(itm.images[0]);
                                                            if (modalRef.current) {
                                                                modalRef.current.scrollIntoView({ behavior: "smooth", block: "center" });
                                                            }
                                                        }}
                                                    >
                                                        <PropertyComponent
                                                            showWidth={true}
                                                            item={itm}
                                                            width={300}
                                                            setPreviewModal={() => setProperty(itm)}
                                                        />
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                )}
                                <div className=" tw-w-full  tw-flex tw-justify-center">
                                    <div className="tw-p-10 tw-max-w-6xl lg:tw-px-0 tw-w-full max-sm:tw-p-5">
                                        <MLSDisclaimer />
                                    </div>
                                </div>
                            </>
                        ) : (
                            <div className="tw-animate-pulse">
                                {/* Image skeleton */}
                                <div className="tw-w-full tw-flex tw-justify-center tw-mb-6">
                                    <div className="tw-max-w-6xl tw-w-full tw-px-5">
                                        <div className="tw-w-full tw-h-96 tw-bg-gray-200 tw-rounded-lg"></div>
                                    </div>
                                </div>

                                {/* Content skeleton */}
                                <div className="tw-min-h-screen tw-bg-white tw-p-6">
                                    <div className="tw-max-w-6xl tw-mx-auto tw-grid tw-grid-cols-1 lg:tw-grid-cols-[1fr_300px] tw-gap-6">
                                        {/* Main content skeleton */}
                                        <div>
                                            {/* Title skeleton */}
                                            <div className="tw-h-8 tw-bg-gray-200 tw-rounded tw-w-3/4 tw-mb-6"></div>

                                            {/* Description skeleton */}
                                            <div className="tw-space-y-2 tw-mb-6">
                                                <div className="tw-h-4 tw-bg-gray-200 tw-rounded tw-w-full"></div>
                                                <div className="tw-h-4 tw-bg-gray-200 tw-rounded tw-w-full"></div>
                                                <div className="tw-h-4 tw-bg-gray-200 tw-rounded tw-w-2/3"></div>
                                            </div>

                                            {/* Facilities skeleton */}
                                            <div className="tw-mb-8">
                                                <div className="tw-h-6 tw-bg-gray-200 tw-rounded tw-w-24 tw-mb-4"></div>
                                                <div className="tw-grid tw-grid-cols-2 lg:tw-grid-cols-4 tw-gap-4">
                                                    {[...Array(8)].map((_, i) => (
                                                        <div key={i} className="tw-flex tw-items-center tw-gap-2">
                                                            <div className="tw-h-6 tw-w-6 tw-bg-gray-200 tw-rounded"></div>
                                                            <div className="tw-h-4 tw-bg-gray-200 tw-rounded tw-w-20"></div>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>

                                            {/* Location skeleton */}
                                            <div>
                                                <div className="tw-h-6 tw-bg-gray-200 tw-rounded tw-w-20 tw-mb-4"></div>
                                                <div className="tw-h-80 tw-bg-gray-200 tw-rounded-lg"></div>
                                            </div>
                                        </div>

                                        {/* Sidebar skeleton */}
                                        <div className="tw-hidden lg:tw-block">
                                            <div className="tw-sticky tw-top-20 tw-bg-white tw-rounded-lg tw-border tw-p-6">
                                                <div className="tw-h-4 tw-bg-gray-200 tw-rounded tw-w-12 tw-mb-2"></div>
                                                <div className="tw-h-8 tw-bg-gray-200 tw-rounded tw-w-32 tw-mb-6"></div>
                                                <div className="tw-h-10 tw-bg-gray-200 tw-rounded tw-w-full tw-mb-4"></div>
                                                <div className="tw-h-4 tw-bg-gray-200 tw-rounded tw-w-28 tw-mb-2"></div>
                                                <div className="tw-h-3 tw-bg-gray-200 tw-rounded tw-w-full tw-mb-1"></div>
                                                <div className="tw-h-3 tw-bg-gray-200 tw-rounded tw-w-3/4 tw-mb-4"></div>
                                                <div className="tw-h-10 tw-bg-gray-200 tw-rounded tw-w-full tw-mb-4"></div>
                                                <div className="tw-h-10 tw-bg-gray-200 tw-rounded tw-w-full"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>

                    {/* {seeAllclicked && <SeeAllImages images={images} setSeeAllclicked={setSeeAllclicked} />} */}
                    <ImageModal
                        isOpen={seeAllclicked}
                        onClose={() => setSeeAllclicked(false)}
                        imageUrl={images}
                        setSeeAllclicked={setSeeAllclicked}
                    />
                    {showTourModal && (
                        <div className="tw-fixed tw-inset-0 tw-bg-black tw-bg-opacity-50 tw-flex tw-items-center tw-justify-center tw-z-50">
                            <div className="tw-bg-white tw-p-4 md:tw-p-8 tw-rounded-lg tw-shadow-lg tw-z-50">
                                <h3 className="tw-text-xl tw-font-bold tw-mb-4">Request a Tour</h3>
                                <div className="tw-flex tw-gap-4">
                                    <CustomDatePickerComponent selectedDate={selectedDate} setSelectedDate={setSelectedDate} />
                                </div>
                                <div className="tw-flex tw-justify-between tw-mt-4">
                                    <button className="tw-bg-orange-500 tw-text-white tw-px-4 tw-py-2 tw-rounded-md" onClick={handleCloseTourModal}>
                                        Cancel
                                    </button>
                                    <button className="tw-bg-green-500 tw-text-white tw-px-4 tw-py-2 tw-rounded-md" onClick={handleScheduleTour}>
                                        Schedule
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}
                    {isReportModalVisible && (
                        <ReportProperty property={property} onClose={() => setIsReportModalVisible(false)} setOpenAuthModal={setOpenAuthModal} />
                    )}
                </div>
            </div>
        </div>
    );
};

export default PreviewPage;
